module.exports = __webpack_public_path__ + "static/media/Mark-Medium.aff52cab.ttf";